module.exports = __webpack_public_path__ + "img/business5.973bd66d.png";